import { useState } from "react";
import "./Menu.scss";
import Categories from "./categories/Categories";
import CoffeeMenu from "../../subpage/menu/itemlisted/Item";
import SelectedItem from "./selecteditem/SelectedItem";
import { Button, App, Modal } from "antd";
import { useStore } from "../../components/globalstate/GlobalState";
import { sendBillAction } from "../../components/action/SendBillAction";
import Invoice from "../../components/invoices/Invoices";

const Menu = () => {
  const [showDetails, setShowDetails] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);
  const [inforBill, setInforBill] = useState([]);
  const { message } = App.useApp()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('Cash')

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const billId = useStore((state) => state.id) ?? localStorage.getItem("billId")

  const handleComplete = () => {
    if (billId) {
      sendBillAction("solved-bill", {}, {}, message, "", paymentMethod);
      localStorage.removeItem("billId");
    }

    setIsModalOpen(false)
    setPaymentMethod("Cash")
  };

  return (
    <div className="frame-menu">
      <Categories onFilterChange={setFilteredItems} />
      <div className="frame-item-list-vs-ordered">
        <div className="item-list">
          <CoffeeMenu coffeeItems={filteredItems || []} />
        </div>

        <div className="ordered-item">
          <div className="frame-item-selected">
            {billId && (
              <SelectedItem
                totalItems={setInforBill}
                filteredToppings={filteredItems.filter((item) => item.type === "Topping") || []}
                billId={billId}
              />
            )}
          </div>

          {filteredItems.length !== 0 && <div className={`frame-print-bill ${showDetails && "active-summary-detail"}`}>
            <div className="order-summary">
              {showDetails && (
                <>
                  <div className="summary-row">
                    <span>Total Items:</span>
                    <strong className="circle-number">{inforBill?.Item_Selected.length}</strong>
                  </div>
                  <div className="summary-row">
                    <span>Total:</span>
                    <strong>{inforBill?.originalTotal}</strong>
                  </div>
                  <div className="summary-row">
                    <span>Tax:</span>
                    <strong style={{ color: "red" }}>
                      {(
                        (parseFloat(inforBill?.Tax) / 100) *
                        inforBill.originalTotal
                      ).toFixed(2)}
                    </strong>
                  </div>
                  <div className="summary-row">
                    <span>Voucher:</span>
                    <strong style={{ color: "rgb(3, 180, 3)" }}>0.00</strong>
                  </div>
                </>
              )}

              <div className="summary-row total">
                <span>Final Total:</span>
                <strong style={{ color: "rgb(3, 180, 3)" }}>
                  ${inforBill?.Total}
                </strong>
              </div>

              <Button
                type="link"
                size="small"
                onClick={() => setShowDetails(!showDetails)}
                disabled={inforBill?.Item_Selected?.length === undefined}
              >
                {showDetails ? "Hide details ▲" : "Show details ▼"}
              </Button>
            </div>

            <Button type="primary" block size="large" onClick={showModal} disabled={inforBill?.Item_Selected?.length === undefined}>
              Process Order
            </Button>
          </div>
          }
        </div>
      </div>
      <Modal
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        width={550}
        centered
        title={<p className="invoice-title-modal">Invoice Details</p>}
      >


        <Invoice
          invoices={inforBill}
          paymentMethod={paymentMethod}
          setPaymentMethod={setPaymentMethod}
          onPrint={handleComplete}
        />
      </Modal>
    </div>
  );
};

export default Menu;
